__turbopack_context__.v({
  "cart": "mobile-menu-module__g4EuLq__cart",
  "glyphs": "mobile-menu-module__g4EuLq__glyphs",
  "hamburger": "mobile-menu-module__g4EuLq__hamburger",
  "inner": "mobile-menu-module__g4EuLq__inner",
  "menu": "mobile-menu-module__g4EuLq__menu",
  "nav": "mobile-menu-module__g4EuLq__nav",
  "overlay": "mobile-menu-module__g4EuLq__overlay",
  "themes": "mobile-menu-module__g4EuLq__themes",
});
